import { AcceptInvitationsDialogComponent } from './accept-invitations-dialog.component';
import { DialogService } from 'primeng/dynamicdialog';
import { TeamInvitationDetails } from '@tokenbox/domain';

export const AcceptInvitationsDialog = (
  pendingInvitations: TeamInvitationDetails[],
): Parameters<typeof DialogService.prototype.open> => [
  AcceptInvitationsDialogComponent,
  {
    header: `New team ${pendingInvitations.length === 1 ? 'invitation' : 'invitations'}`,
    modal: true,
    closable: true,
    closeOnEscape: true,
  },
];
